export function getPositionsValuesFormatted(position) {
  return {
    cf_buy_average_price: Number(position.cf_buy_average_price) || 0,
    cf_sell_average_price: Number(position.cf_sell_average_price) || 0,
    actual_average_buy_price: Number(position.actual_average_buy_price) || 0,
    actual_average_sell_price: Number(position.actual_average_sell_price) || 0,
    actual_cf_buy_amount: Number(position.actual_cf_buy_amount) || 0,
    actual_cf_sell_amount: Number(position.actual_cf_sell_amount) || 0,
    average_buy_price: Number(position.average_buy_price) || 0,
    average_price: Number(position.average_price) || 0,
    average_sell_price: Number(position.average_sell_price) || 0,
    buy_amount: Number(position.buy_amount) || 0,
    buy_quantity: Number(position.buy_quantity) || 0,
    cf_buy_amount: Number(position.cf_buy_amount) || 0,
    cf_buy_quantity: Number(position.cf_buy_quantity) || 0,
    cf_sell_amount: Number(position.cf_sell_amount) || 0,
    cf_sell_quantity: Number(position.cf_sell_quantity) || 0,
    client_id: position.client_id,
    close_price: Number(position.close_price) || 0,
    exchange: position.instrument_identifier === "INDICES" ? "NSE" : position.exchange,
    instrument_token: Number(position.instrument_token) || 0,
    ltp: Number(position.ltp) || 0,
    isLTPHigh: position.isLTPHigh,
    multiplier: Number(position.multiplier) || 1,
    net_quantity: Number(position.net_quantity) || 0,
    net_amount: Number(position.net_amount) || 0,
    previous_close: Number(position.previous_close) || 0,
    pro_cli: position.pro_cli,
    prod_type: position.prod_type,
    product: position.product,
    realized_mtm: Number(position.realized_mtm) || 0,
    segment: position.segment,
    sell_amount: Number(position.sell_amount) || 0,
    sell_quantity: Number(position.sell_quantity) || 0,
    symbol: position.symbol,
    token: Number(position.token) || 0,
    trading_symbol: position.trading_symbol,
    display_symbol: position.display_symbol,
    v_login_id: position.v_login_id,
    xe_uuid: position.xe_uuid,
    rmtm_buy_average_price: position.rmtm_buy_average_price || 0,
    rmtm_sell_average_price: position.rmtm_sell_average_price || 0,
    instrument_identifier: position.instrument_identifier,
    price_precision: position.price_precision,
    category: position.category,
    blocked_margin: Number(position.blocked_margin) || 0,
  };
}

export function getOptionsValueFormatted(options) {
  return {
    close_price: Number(options.close_price) || 0,
    display_name: options.display_name,
    exchange: options.exchange,
    strike_price: Number(options.strike_price) || 0,
    symbol: options.symbol,
    token: Number(options.token) || 0,
    trading_symbol: options.trading_symbol,
    ltp: Number(options.ltp) || 0,
    initialOpenInterest: Number(options.initialOpenInterest) || 0,
    currentOpenInterest: Number(options.currentOpenInterest) || 0,
    delta: Number(options.delta) || 0,
    theta: Number(options.theta) || 0,
    gamma: Number(options.gamma) || 0,
    rho: Number(options.rho) || 0,
    vega: Number(options.vega) | 0,
    iv: Number(options.iv) || 0
  }
}

export function getHoldingsValuesFormatted(holding) {
  return {
    actual_buy_avg: Number(holding.actual_buy_avg) || 0,
    branch_code: holding.branch_code,
    buy_avg: Number(holding.buy_avg) || 0,
    buy_avg_mtm: Number(holding.buy_avg_mtm) || 0,
    client_id: holding.client_id,
    exchange: holding.exchange,
    instrument_details: {
      exchange: Number(holding.instrument_details.exchange) || 0,
      instrument_name: holding.instrument_details.instrument_name,
      instrument_token:
        Number(holding.instrument_details.instrument_token) || 0,
      trading_symbol: holding.instrument_details.trading_symbol,
    },
    isin: holding.isin,
    ltp: Number(holding.ltp) || 0,
    isLTPHigh: holding.isLTPHigh,
    previous_close: Number(holding.previous_close) || 0,
    product: holding.product,
    quantity: Number(holding.quantity) || 0,
    symbol: holding.symbol,
    t0_price: Number(holding.t0_price) || 0,
    t0_quantity: Number(holding.t0_quantity) || 0,
    t1_price: Number(holding.t1_price) || 0,
    t1_quantity: Number(holding.t1_quantity) || 0,
    t2_price: Number(holding.t2_price) || 0,
    t2_quantity: Number(holding.t2_quantity) || 0,
    token: Number(holding.token) || 0,
    trading_symbol: holding.trading_symbol,
    used_quantity: Number(holding.used_quantity) || 0,
    transaction_type: holding.transaction_type ? holding.transaction_type : 'NA',
    free_quantity: Number(holding.free_quantity) || 0,
    pending_quantity: Number(holding.pending_quantity) || 0,
    pledge_quantity: Number(holding.pledge_quantity) || 0,
    today_pledge_quantity: Number(holding.today_pledge_quantity) || 0,
    withheld_qty: Number(holding.withheld_qty) || 0,
    collateral_quantity: Number(holding.collateral_quantity) || 0,
    pledge_allow: holding.pledge_allow || false,
    today_pledge_quantity: holding.today_pledge_quantity || 0,
    net_holding_quantity: Number(holding.net_holding_quantity) || 0,
    today_unpledge_quantity: holding.hasOwnProperty("today_unpledge_quantity") ? Number(holding.today_unpledge_quantity) : -1
  };
}
